import { initState } from './state';

export default {
	USER_LOGGED_IN(state, {user, source}) {
		state.user = user;
		state.source = !source ? 'cognito' : source;
	},
	USER_LOGGED_OUT(state) {
		// state.user = null;
		Object.assign(state, initState());
	},
	UPDATE_USER_DATA(state, {userData, source}) {
		state.user = {
			...state.user,
			...userData
		};

		if (source) {
			state.source = source;
		}
	},
	UPDATE_USER_DATA_ONLY(state, {userData}) {
		state.user = {
			...state.user,
			...userData
		};
	}
};